//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModelDeclarations } from "wint-api-client/dist/types";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

function useDeclarationService() {
  const { apiClientInstance } = useAPIClientHelper();

  const saveDeclarationData = async (declaration: WintSuperkollAPIModelDeclarations.Declaration) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).DeclarationClient.SaveDeclarationDataAsync(declaration);
  };

  return {
    saveDeclarationData,
  };
}

export default useDeclarationService;
